import { render, staticRenderFns } from "./FormEditDetailOwner.vue?vue&type=template&id=d571c096"
import script from "./FormEditDetailOwner.vue?vue&type=script&lang=js"
export * from "./FormEditDetailOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports